<template>
  <footer class="footer">
    <div class="footer-top">
      <div class="footer-container">
        <!-- Brand Column -->
        <div class="footer-brand">
          <div class="footer-logo">
            <img src="@/assets/logo-icon-white.png" alt="" class="footer-logo-icon" aria-hidden="true" />
            <span class="footer-logo-text">Fulfilldrop</span>
          </div>
          <p class="footer-tagline">End-to-end cross-border supply chain execution — built for fast-growing ecommerce brands.</p>
          <div class="footer-social">
            <a href="#" class="social-btn" title="WhatsApp"><i class="fa-brands fa-whatsapp"></i></a>
            <a href="#" class="social-btn" title="Instagram"><i class="fa-brands fa-instagram"></i></a>
            <a href="#" class="social-btn" title="YouTube"><i class="fa-brands fa-youtube"></i></a>
            <a href="#" class="social-btn" title="Facebook"><i class="fa-brands fa-facebook-f"></i></a>
            <a href="#" class="social-btn" title="LinkedIn"><i class="fa-brands fa-linkedin-in"></i></a>
          </div>
        </div>

        <!-- Nav Columns -->
        <div class="footer-nav-col">
          <h4 class="footer-nav-title">{{ t.footer.solutions }}</h4>
          <ul>
            <li><router-link to="/solutions">{{ t.footer.dropshipping }}</router-link></li>
            <li><router-link to="/solutions">{{ t.footer.fulfillment }}</router-link></li>
            <li><router-link to="/solutions">{{ t.footer.logistics }}</router-link></li>
            <li><router-link to="/solutions">{{ t.footer.custom }}</router-link></li>
            <li><router-link to="/solutions">POD / Customization</router-link></li>
          </ul>
        </div>

        <div class="footer-nav-col">
          <h4 class="footer-nav-title">{{ t.footer.about }}</h4>
          <ul>
            <li><router-link to="/about">{{ t.footer.company }}</router-link></li>
            <li><router-link to="/about">{{ t.footer.team }}</router-link></li>
            <li><a href="#">{{ t.footer.news }}</a></li>
            <li><a href="#">{{ t.footer.careers }}</a></li>
            <li><router-link to="/faq">FAQ</router-link></li>
          </ul>
        </div>

        <div class="footer-nav-col">
          <h4 class="footer-nav-title">{{ t.footer.support }}</h4>
          <ul>
            <li><a href="#">{{ t.footer.help }}</a></li>
            <li><router-link to="/faq">{{ t.footer.faq }}</router-link></li>
            <li><a href="#" @click.prevent="scrollToContact">{{ t.footer.contact }}</a></li>
            <li><a href="#">{{ t.footer.privacy }}</a></li>
            <li><a href="#">Terms of Service</a></li>
          </ul>
        </div>

        <!-- Contact -->
        <div class="footer-contact-col">
          <h4 class="footer-nav-title">{{ t.footer.contactInfo }}</h4>
          <div class="footer-contact-list">
            <div class="footer-contact-item">
              <div class="footer-contact-icon"><i class="fa-solid fa-phone"></i></div>
              <span>{{ t.footer.phone }}</span>
            </div>
            <div class="footer-contact-item">
              <div class="footer-contact-icon"><i class="fa-brands fa-whatsapp"></i></div>
              <span>{{ t.footer.whatsapp }}</span>
            </div>
            <div class="footer-contact-item">
              <div class="footer-contact-icon"><i class="fa-solid fa-envelope"></i></div>
              <span>{{ t.footer.email }}</span>
            </div>
          </div>
          <div class="footer-platforms">
            <div class="footer-platform-badge"><i class="fa-brands fa-shopify"></i> Shopify</div>
            <div class="footer-platform-badge"><i class="fa-brands fa-wordpress"></i> WooCommerce</div>
            <div class="footer-platform-badge"><i class="fa-brands fa-amazon"></i> Amazon</div>
          </div>
        </div>
      </div>
    </div>

    <div class="footer-bottom">
      <div class="footer-bottom-inner">
        <p class="footer-copyright">{{ t.footer.copyright }}</p>
        <div class="footer-bottom-links">
          <a href="#">Privacy Policy</a>
          <span class="footer-bottom-divider">·</span>
          <a href="#">Terms of Service</a>
          <span class="footer-bottom-divider">·</span>
          <a href="#">Cookie Policy</a>
        </div>
      </div>
    </div>
  </footer>
</template>

<script>
import { getSafeTranslator } from '../assets/languages.js'

export default {
  name: 'Footer',
  props: { currentLang: { type: String, default: 'en' } },
  computed: {
    t() { return getSafeTranslator(this.currentLang) }
  },
  methods: {
    scrollToContact() {
      const el = document.getElementById('contact')
      if (el) el.scrollIntoView({ behavior: 'smooth' })
    }
  }
}
</script>

<style scoped>
.footer {
  font-family: 'Inter', -apple-system, BlinkMacSystemFont, sans-serif;
  background: #0f172a;
  color: #f8fafc;
}

/* TOP */
.footer-top {
  padding: 5rem 0 3rem;
  border-bottom: 1px solid rgba(255,255,255,0.08);
}
.footer-container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 2rem;
  display: grid;
  grid-template-columns: 2fr 1fr 1fr 1fr 1.5fr;
  gap: 3rem;
}

/* Brand */
.footer-brand {}
.footer-logo {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-bottom: 1.2rem;
}
.footer-logo-icon { height: 38px; width: auto; display: block; }
.footer-logo-text {
  font-family: 'Inter', -apple-system, BlinkMacSystemFont, sans-serif;
  font-size: 1.3rem;
  font-weight: 700;
  color: #f8fafc;
  letter-spacing: -0.02em;
}
.footer-tagline {
  font-size: 0.88rem;
  color: #94a3b8;
  line-height: 1.65;
  margin-bottom: 1.5rem;
  max-width: 260px;
}
.footer-social {
  display: flex; gap: 0.6rem;
}
.social-btn {
  width: 36px; height: 36px;
  border-radius: 9px;
  background: rgba(255,255,255,0.07);
  border: 1px solid rgba(255,255,255,0.1);
  color: #94a3b8;
  display: flex; align-items: center; justify-content: center;
  font-size: 0.9rem;
  text-decoration: none;
  transition: background 0.2s, color 0.2s, border-color 0.2s;
}
.social-btn:hover {
  background: #28b5c1;
  border-color: #28b5c1;
  color: #fff;
}

/* Nav Cols */
.footer-nav-col {}
.footer-nav-title {
  font-size: 0.82rem;
  font-weight: 700;
  letter-spacing: 0.1em;
  text-transform: uppercase;
  color: #fff;
  margin-bottom: 1.4rem;
}
.footer-nav-col ul {
  list-style: none;
  padding: 0; margin: 0;
  display: flex; flex-direction: column; gap: 0.7rem;
}
.footer-nav-col a {
  font-size: 0.88rem;
  color: #94a3b8;
  text-decoration: none;
  transition: color 0.2s;
  display: inline-block;
}
.footer-nav-col a:hover { color: #fff; }

/* Contact */
.footer-contact-col {}
.footer-contact-list {
  display: flex; flex-direction: column; gap: 0.9rem;
  margin-bottom: 1.5rem;
}
.footer-contact-item {
  display: flex; align-items: flex-start; gap: 0.7rem;
}
.footer-contact-icon {
  width: 28px; height: 28px;
  border-radius: 7px;
  background: rgba(40,181,193,0.2);
  display: flex; align-items: center; justify-content: center;
  color: #a5b4fc;
  font-size: 0.8rem;
  flex-shrink: 0;
}
.footer-contact-item span {
  font-size: 0.82rem;
  color: #94a3b8;
  line-height: 1.5;
}

/* Platform Badges */
.footer-platforms {
  display: flex; flex-wrap: wrap; gap: 0.5rem;
}
.footer-platform-badge {
  display: inline-flex; align-items: center; gap: 0.35rem;
  font-size: 0.75rem; font-weight: 600;
  color: #94a3b8;
  background: rgba(255,255,255,0.05);
  border: 1px solid rgba(255,255,255,0.1);
  border-radius: 7px;
  padding: 0.3rem 0.65rem;
}

/* BOTTOM */
.footer-bottom {
  padding: 1.5rem 0;
}
.footer-bottom-inner {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 2rem;
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 1rem;
}
.footer-copyright {
  font-size: 0.82rem;
  color: #64748b;
}
.footer-bottom-links {
  display: flex; align-items: center; gap: 0.7rem;
}
.footer-bottom-links a {
  font-size: 0.82rem;
  color: #64748b;
  text-decoration: none;
  transition: color 0.2s;
}
.footer-bottom-links a:hover { color: #94a3b8; }
.footer-bottom-divider { color: #334155; font-size: 0.75rem; }

@media (max-width: 1024px) {
  .footer-container {
    grid-template-columns: 1fr 1fr 1fr;
    gap: 2.5rem;
  }
  .footer-brand { grid-column: 1 / -1; }
}
@media (max-width: 768px) {
  .footer-container {
    grid-template-columns: 1fr 1fr;
    gap: 2rem;
  }
  .footer-brand { grid-column: 1 / -1; }
}
@media (max-width: 480px) {
  .footer-container { grid-template-columns: 1fr; }
  .footer-bottom-inner { flex-direction: column; align-items: flex-start; }
}
</style>
